<template>
    <div class="my-question-asw" v-loading="loading">
        <tab-header
            :tabList="questionTabList"
            :tabName="tabName"
            :isSelf="isSelf"
            @getTabName="getTabName"
            @getSortType="getSortType">
        </tab-header>
        <section class="question-asw-content" v-loading="isLoading">
            <ul class="question-asw-list" v-if="questionAswList.length">
                <!-- 我的提问 / 我的关注 -->
                <template v-if="curTabName !== 'my_answer'">
                    <li :class="[`data-item data-item${item.id}`]" v-for="(item,index) in questionAswList" :key="index">
                        <div class="head">
                            <span v-if="item.comment_is_accept_by_topic" class="tag solved">已解决</span>
                            <h3  @click="goQuestionDetail(item)" :class="['question-name', {'is-delete': item.status === 'Delete'}]">
                                {{item.title}}
                            </h3>
                            <span v-if="item.status === 'Delete'" class="tag deleted">已删除</span>
                        </div>
                        <!-- 底部操作区 -->
                        <div class="comment-bottom-content">
                            <div class="answer-list">
                                <p class="answer-text comment" @click="goQuestionDetail(item, true)">
                                    <i class="smart-img"></i>
                                    <span>{{item.no_of_comment}}<i class="text">回答</i></span>
                                </p>
                                <p class="answer-text view">
                                    <i class="smart-icon view-icon"></i>
                                    <span>{{item.no_of_views | transformUnit}}<i class="text">阅览</i></span>
                                </p>
                                <el-tooltip
                                    effect="dark"
                                    :content="item.is_followed ? '取消关注' : '关注问题'"
                                    placement="top">
                                    <p class="answer-text followed" @click="handleFollowToggle(item)" :class="{'active': item.is_followed}">
                                        <i class="smart-img follow-icon"></i>
                                        <span>{{item.no_of_followed}}<i class="text">关注</i></span>
                                    </p>
                                </el-tooltip>
                                <template v-if="isSelf && item.created_by.user_id === userId">
                                    <p class="answer-text edit" @click="editeArticle(item.id)">
                                        <i class="smart-img"></i>
                                        <span>编辑</span>
                                    </p>
                                    <p class="answer-text delete" @click="deleteArticle(item.id)">
                                        <i class="smart-img"></i>
                                        <span>删除</span>
                                    </p>
                                </template>
                            </div>
                            <p class="topic-people">{{item.created_by.nick_name}} 于 {{item.created_on}}发布</p>
                        </div>
                    </li>
                </template>
                <!-- 我的回答 -->
                <template v-else>
                    <li :class="[`data-item data-item${item.id}`, 'is-answer']" v-for="(item,index) in questionAswList" :key="index">
                        <h3  @click="goQuestionDetail({ id: item.topic_id })" class="question-name">
                            {{item.topic_title}}
                        </h3>
                        <answer
                            :key="item.id"
                            :comment="item"
                            :isSelf="isSelf"
                            @goHomePage="goHomePage"
                            @deleteArticle="deleteArticle"
                            @onApproval="onApproval">
                        </answer>
                    </li>
                </template>
            </ul>
            <!-- 无数据 -->
            <div class="content-empty" v-show="!questionAswList.length && !isLoading">
                <img src="../../images/personal_center/data-null.png" alt="" />
                <p>暂无数据</p>
            </div>
            <!-- 滚动加载loading -->
            <div class="load-more" v-if="isMoreLoading || questionAswList.length">
                <img v-if="isMoreLoading" alt="loading" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ totalPage === curPage ? '没有更多内容了' : '显示更多' }}</span>
            </div>
        </section>
    </div>
</template>

<script>
import tabHeader from './tabHeader.vue'
import wangEditor from '../community/wangEditor.vue'
import answer from './my_question/answer.vue'
import personalCenter from '@/mixins/personalCenter.js'
export default {
    components: {
        tabHeader,
        wangEditor,
        answer
    },
    mixins: [ personalCenter ],
    data () {
        return {
            questionTabList: [
                {
                    label: '的提问',
                    name: 'my_question',
                    count: 0
                },
                {
                    label: '的回答',
                    name: 'my_answer',
                    count: 0
                },
                {
                    label: '关注的提问',
                    name: 'follow_qa',
                    count: 0
                }
            ],
            curTabName: '',
            tabName: 'my_question',
            questionAswList: [],
            sortType: '-created_on'
        }
    },
    watch: {
        statisticsInfo: {
            handler (val) {
                if (!val) return
                // 设置默认条数
                this.questionTabList.forEach(item => {
                    const type = item.name === 'my_question'
                        ? 'qa_num'
                        : item.name === 'my_answer'
                        ? 'qa_comment_num'
                        : 'follow_num'
                    item.count = this.statisticsInfo[type]
                })
            },
           immediate: true
        }
    },
    methods: {
        // 切换tab
        getTabName (name) {
            this.tabName = name || 'my_question'
            this.curPage = 1
            this.getQuestionAswList()
        },
        // 我的数据列表
        async getQuestionAswList (tabName = this.tabName, isMore) {
            try {
                if (isMore) {
                    this.isMoreLoading = true
                } else {
                    this.isLoading = !this.loading
                }

                const params = {
                    page: this.curPage,
                    page_size: 10,
                    board: 'qa',
                    ordering: this.sortType
                }
                if (tabName === 'my_question') {
                    params.status = 'Published'
                    params.user = this.userId
                } else if (tabName === 'follow_qa') {
                    params.followed_user = this.userId
                } else {
                    params.user = this.userId
                }
                const path = tabName === 'my_answer' ? 'forum/comments/' : 'forum/topics/'
                await axios.get(myUrl + path, {
                    params
                }).then(res => {
                    const resp = res.data
                    if (!resp.result) return
                    // 设置tab关注数
                    const tab = this.questionTabList.find(item => item.name === tabName)
                    tab.count = resp.data.count

                    this.totalPage = Math.ceil(resp.data.count / 10)
                    this.isPageOver = this.curPage >= this.totalPage
                    let questionAswList = []
                    if (tabName === 'my_answer') {
                        questionAswList = resp.data.results.map(item => {
                            this.$set(item, 'isViewDetail', false)
                            return item
                        })
                    } else {
                        questionAswList = resp.data.results
                    }
                    if (isMore) {
                        this.questionAswList.push(...questionAswList)
                    } else {
                        this.questionAswList = questionAswList
                    }
                    if (this.tabName === 'my_answer') {
                        this.$nextTick(() => {
                            this.setCommentShowMore()
                        })
                    }
                    this.curTabName = this.tabName
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.loading = false
                this.isLoading = false
                this.isMoreLoading = false
            }
        },
        // 给所有高超过3行的评论设置显示更多
        setCommentShowMore () {
            this.questionAswList.forEach(item => {
                const topicDom = document.querySelector(`.data-item${item.id}`)
                const descDom = topicDom && topicDom.querySelector('.comment-desc .desc')
                if (!descDom) return
                const height = descDom.getBoundingClientRect().height
                item.isViewDetail = height > 44
            })
        },
        // 赞同
        onApproval (data) {
            if (this.isLogin) {
                const comment = this.questionAswList.find(item => item.id === data.id)
                let params = {
                    action: comment.is_vote_up ? 'down' : 'up',
                    parent_id: comment.id
                }
                axios.post(myUrl + 'forum/usercomment/', qs.stringify(params)).then(res => {
                    if (comment.is_vote_up) {
                        comment.vote_up_num--
                    } else {
                        comment.vote_up_num++
                    }
                    comment.is_vote_up = !comment.is_vote_up
                })
            } else {
                axios.get(myUrl + 'login/test/')
            }
        },
        // 前往文章详情
        goQuestionDetail (item, isComment) {
            if (isComment) {
                localStorage.setItem('commentWrapper', true)
            }
            let routeData = this.$router.resolve({
                name: 'Question',
                params: {
                    wid: item.id
                },
                query: {
                    type: 'answer'
                }
            })
            window.open(routeData.href, '_blank')
        },
        // 关注&取消关注
        handleFollowToggle (item) {
            try {
                if (!this.isLogin) {
                    axios.get(myUrl + 'login/test/')
                    return
                }
                let params = {
                    topic_id: item.id,
                    is_followed: !item.is_followed
                }
                axios.post(myUrl + 'forum/usertopic/', qs.stringify(params)).then((res) => {
                    if (res.data.result) {
                        item.is_followed = !item.is_followed
                        const curTab = this.questionTabList.find(item => item.name === 'follow_qa')
                        let msg = ''
                        if (item.is_followed) {
                            item.no_of_followed += 1
                            msg = '关注成功'
                            curTab.count++
                        } else {
                            item.no_of_followed -= 1
                            msg = '取消关注成功'
                            curTab.count--
                        }
                        // 在我的关注里切换关注态则清除掉该帖子
                        if (this.isSelf && this.tabName === 'follow_qa') {
                            const index = this.questionAswList.findIndex(val => val.id === item.id)
                            this.questionAswList.splice(index, 1)
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 前往个人主页
        goHomePage (userInfo) {
            // 判断是否为自己或者他人
            const isMatch = this.userId === userInfo.id
            const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userInfo.id}`
            let routeData = this.$router.resolve({
                path
            })
            window.open(routeData.href, '_blank')
        },
        // 编辑
        editeArticle (id) {
            const routeData = this.$router.resolve({
                path: `/s-mart/community/ask/${id}/`
            })
            window.open(routeData.href, '_blank')
        },
        // 删除
        deleteArticle (articleId, commentId) {
            if (!this.isLogin) {
                axios.get(myUrl + 'login/test/')
                return
            }
            this.$bkInfo({
                title: '确认要删除？',
                confirmFn: () => {
                    this.deleteQuestion(articleId, commentId)
                }
            })
        },
        // 删除问题回调
        deleteQuestion (articleId, commentId) {
            try {
                const url = commentId ? `forum/comment/${commentId}/` : `forum/topics/${articleId}/`
                axios.delete(myUrl + url).then(res => {
                    if (res.data.result) {
                        // 将对应列表中id对应的帖子删除
                        if (commentId) {
                            const index = this.questionAswList.findIndex(article => article.id === commentId)
                            this.questionAswList.splice(index, 1)
                        } else {
                            const index = this.questionAswList.findIndex(article => article.id === articleId)
                            this.questionAswList.splice(index, 1)
                            // 如果删除帖子是关注态则需要将我的关注数量减一
                            const dataInfo = this.questionAswList.find(article => article.id === articleId)
                            if (dataInfo.is_followed) {
                                const curTab = this.questionTabList.find(item => item.name === 'follow_qa')
                                curTab.count--
                            }
                        }
                        const name = commentId ? 'my_answer' : 'my_question'
                        const curTab = this.questionTabList.find(item => item.name === name)
                        curTab.count--
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 切换排序类型
        getSortType (sort) {
            this.sortType = sort
            this.curPage = 1
            this.getQuestionAswList()
        },
        // 监听滚动
        handleScroll () {
            // 滚动加载
            this.scrollLoading(this.getQuestionAswList)
        }
    }
}
</script>
<style lang="scss">
    @import '@/scss/scrollbar.scss';
    .edit-comment {
        height: 228px;
        .w-e-toolbar {
            height: 42px;
            line-height: 32px;
            .w-e-menu {
                height: 37px;
            }
            &:first-child .w-e-droplist {
                height: 150px !important;
                overflow-y: auto;
                @include scrollbar;
            }
        }
        .w-e-text-container {
            height: 120px !important;
            background: #fff;
        }
    }
    .my-question-asw {
        .el-loading-mask {
            .el-loading-spinner {
                top: 250px !important;
            }
        }
    }
    .my-question-asw .comment-bottom-content {
        margin-top: 23px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #63656e;
        padding: 0 6px 20px 0;
        border-bottom: 1px solid #f0f1f5;
        .answer-list {
            font-size: 0;
            display: flex;
            align-items: center;
        }
        .answer-text {
            display: flex;
            align-items: center;
            margin-right: 40px;
            padding-left: 3px;
            line-height: 14px;
            font-size: 12px;
            color: #63656e;
            cursor: pointer;
            .smart-icon {
                font-size: 12px;
                margin-right: 5px;
            }
            .smart-img {
                height: 16px;
                width: 16px;
                position: relative;
                z-index: 2;
                margin-right: 5px;
                display: inline-block;
                &::before, &::after {
                    content: '';
                    height: 16px;
                    width: 16px;
                    position: absolute;
                    z-index: -1;
                    display: none;
                }
            }
            &.view {
                cursor: default;
                color: #63656e;
                .smart-icon {
                    height: 16px;
                    width: 16px;
                }
                .view-icon {
                    background: url('../../images/community/eye-open.png');
                    background-size: 100% 100%;
                }
            }
            &.comment {
                .smart-img {
                    background: url('../../images/community/comment3.png');
                    background-size: 100% 100%;
                    &::before {
                        background: url('../../images/community/comment4.png');
                        background-size: 100% 100%;
                    }
                    &::after {
                        background: url('../../images/community/comment5.png');
                        background-size: 100% 100%;
                    }
                }
            }
            &.followed {
                .smart-img {
                    background: url('../../images/community/like3.png');
                    background-size: 100% 100%;
                    &::before {
                        background: url('../../images/community/like4.png');
                        background-size: 100% 100%;
                    }
                    &::after {
                        background: url('../../images/community/like5.png');
                        background-size: 100% 100%;
                    }
                }
            }
            &.edit {
                .smart-img {
                    background: url('../../images/personal_center/edit.png');
                    background-size: 100% 100%;
                    &::before {
                        background: url('../../images/personal_center/edit2.png');
                        background-size: 100% 100%;
                    }
                }
            }
            &.delete {
                .smart-img {
                    background: url('../../images/personal_center/delete.png');
                    background-size: 100% 100%;
                }
                &:hover .smart-img {
                    background: url('../../images/community/delete2.png');
                    background-size: 100% 100%;
                }
            }
            &:hover {
                &:not(.view) {
                    color: #3a84ff;
                    .smart-img::before {
                        display: block;
                        z-index: 3;
                    }
                }
            }
            &.active {
                color: #3a84ff;
                .smart-img {
                    background: none;
                    &::before {
                        display: none !important;
                    }
                    &::after {
                        display: block;
                        z-index: 3;
                    }
                }
            }
            .text {
                margin-left: 2px;
                font-style: initial;
            }
        }
        .topic-people {
            font-size: 12px;
            line-height:19px;
        }
    }
</style>

<style lang="scss" scoped>

    .my-question-asw {
        width: 1200px;
        margin: 0 auto 17px;
        background: #fff;
        padding-bottom: 20px;
    }
    .question-asw-content {
        min-height: 320px;
        padding: 0 20px;
    }
    .data-item {
        padding-top: 20px;
        &.is-answer {
            padding-top: 23px;
            .comment-bottom-content {
                padding-bottom: 10px !important;
            }
        }
        .tag {
            padding: 2px 7px;
            flex-shrink: 0;
            margin-right: 7px;
            line-height: 16px;
            font-size: 12px;
            border-radius: 2px;
        }
        .head{
            display: flex;
            align-items: flex-start;
            .solved {
                color: #14a568;
                background: #e4faf0;
            }
            .deleted {
                background: #feebea;
                color: #ea3536;
                margin: 0 0 0 7px;
            }
        }
        .question-name{
            display: inline-block;
            word-break: break-all;
            cursor: pointer;
            font-size: 16px;
            line-height: 20px;
            color: #313238;
            font-weight: bold;
            transition: all 0.3s ease;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 1000px;
            &:hover {
                color: #3a84ff;
            }
            &.is-delete {
                color: #c4c6cc;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// my_question.vue?d7b1b1c4